<template>
  <div>
    <div class="mb-4 flex items-center">
      <h3 class="text-lg font-semibold uppercase tracking-wide text-primary">
        Device Twin
      </h3>
      <hr class="mx-4 flex-1 border-primary" />
    </div>
    <div v-if="viewState == 'Idle'">
      <div v-if="client.is_activated" class="border rounded-lg p-5">
        <pre class="bg-gray-100 border rounded border-gray-400 p-4 text-sm overflow-auto max-h-96">{{ formattedClientProperties }}</pre>
        <p class="text-sm font-semibold text-gray-700 mt-4">
          Last Updated:
          {{ $moment(lastUpdatedDate).format("DD/MM/YYYY [at] HH:mm") }}
        </p>
      </div>
      <div v-else class="flex flex-wrap">
        <p class="mx-auto my-16">
          This client is not activated. Once activated, this panel will become
          available.
        </p>
      </div>
    </div>
    <div
      v-else-if="viewState == 'Loading'"
      class="flex w-full justify-center py-20"
    >
      <Spinner :color="'text-black'" :size="10" />
    </div>
  </div>
</template>

<script>
const Spinner = () => import("@/components/Spinner.vue");

export default {
  name: "DeviceTwin",
  components: {
    Spinner,
  },
  props: {
    client: Object,
  },
  async mounted() {
    await this.getClientProperties();
  },
  data() {
    return {
      viewState: "Idle",
      formattedClientProperties: null,
      lastUpdatedDate: null,
    };
  },
  methods: {
    async getClientProperties() {
      if (!this.client.is_activated) return;

      this.viewState = "Loading";

      const data = await this.iVClientService.getClientDeviceProperties(
        this.client.client_id,
      );

      // Format the JSON with proper indentation for display
      this.formattedClientProperties = JSON.stringify(data, null, 2);
      this.lastUpdatedDate = data.$metadata.$lastUpdated;
      
      this.viewState = "Idle";
    },
  },
};
</script>
